
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/blog",
      function () {
        return require("private-next-pages/[region]/blog/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/blog"])
      });
    }
  